import { __extends } from "tslib";
import { Utils } from "@singularsystems/neo-core";
import React from "react";
import { IconFactory } from ".";
/**
 * Font factory that renders google material symbols icons.
 */
var MaterialSymbolsFontFactory = /** @class */ (function (_super) {
    __extends(MaterialSymbolsFontFactory, _super);
    function MaterialSymbolsFontFactory(options) {
        var _a;
        var _this = _super.call(this) || this;
        _this.filledByDefault = (_a = options === null || options === void 0 ? void 0 : options.fillDefault) !== null && _a !== void 0 ? _a : false;
        if ((options === null || options === void 0 ? void 0 : options.fontAwesomeMappings) && (options === null || options === void 0 ? void 0 : options.replaceNeoMappings)) {
            _this.fontAwesomeMap = new Map(options.fontAwesomeMappings);
        }
        else {
            _this.fontAwesomeMap = new Map(neoFontAwesomeMappings);
            if (options === null || options === void 0 ? void 0 : options.fontAwesomeMappings) {
                for (var _i = 0, _b = options.fontAwesomeMappings; _i < _b.length; _i++) {
                    var mapping = _b[_i];
                    _this.fontAwesomeMap.set(mapping[0], mapping[1]);
                }
            }
        }
        return _this;
    }
    MaterialSymbolsFontFactory.prototype.mapStringToIcon = function (iconName, style) {
        var _a;
        var className = "material-symbols-outlined";
        var isFilled = (_a = style === null || style === void 0 ? void 0 : style.solid) !== null && _a !== void 0 ? _a : this.filledByDefault;
        // TODO: copy spin animation from font-awesome
        if (style === null || style === void 0 ? void 0 : style.spin) {
            className += " fa fa-spin";
        }
        // remove and extract convention styling
        iconName = iconName.replace("fa-fw", "");
        var faProps = Utils.getFontAwesomeIconProps(iconName);
        iconName = faProps.name.trim();
        if (faProps.isSolid !== undefined) {
            isFilled = faProps.isSolid;
        }
        var mappedName = this.mapFontAwesomeToMaterial(iconName);
        if (mappedName === undefined) {
            // replace common differences.
            mappedName = iconName.replace(/-/g, "_")
                .replace("plus", "add")
                .replace("square", "box");
        }
        if (mappedName === "") {
            mappedName = '\u00A0';
        }
        var cssStyle;
        if (isFilled || (style === null || style === void 0 ? void 0 : style.weight)) {
            var styleText = "";
            if (isFilled) {
                styleText += "'FILL' 1";
            }
            if (style === null || style === void 0 ? void 0 : style.weight) {
                styleText += " 'wght' " + style.weight;
            }
            cssStyle = { fontVariationSettings: styleText.trim() };
        }
        return React.createElement("span", { className: className, style: cssStyle }, mappedName);
    };
    MaterialSymbolsFontFactory.prototype.mapFontAwesomeToMaterial = function (faName) {
        return this.fontAwesomeMap.get(faName.trim());
    };
    return MaterialSymbolsFontFactory;
}(IconFactory));
export { MaterialSymbolsFontFactory };
var neoFontAwesomeMappings = [
    ["plus", "add"],
    ["plus-square", "add_box"],
    ["minus", "remove"],
    ["minus-square", "indeterminate_check_box"],
    ["arrow-left", "arrow_back"],
    ["angle-left", "chevron_left"],
    ["caret-left", "arrow_left"],
    ["trash", "delete"],
    ["user", "person"],
    ["users", "groups"],
    ["user-shield", "admin_panel_settings"],
    ["user-plus", "person_add"],
    ["user-times", "person_remove"],
    ["user-lock", "manage_accounts"],
    ["unlock", "lock_open"],
    ["cogs", "settings"],
    ["file-excel", "text_snippet"],
    ["file-code", "code_blocks"],
    ["feather-alt", "filter_alt"],
    ["filter", "filter_alt"],
    ["eye", "visibility"],
    ["envelope", "mail"],
    ["address-book", "contact_mail"],
    ["at", "alternate_email"],
    ["bell", "notifications"],
    ["times", "close"],
    ["eraser", "ink_eraser"],
    ["align-left", "format_align_left"],
    ["align-center", "format_align_center"],
    ["align-right", "format_align_right"],
    ["equals", "equal"],
    ["not-equal", "block"],
    ["copy", "content_copy"],
    ["chart-bar", "bar_chart"],
    ["less-than", ""],
    ["less-than-equal", ""],
    ["greater-than", ""],
    ["greater-than-equal", ""],
    ["stamp", "approval"],
    ["circle-notch", "progress_activity"]
];
